import React from 'react'
import { Col, Row } from 'antd'
import { TrustedPersonForm } from '@shared/TrustedPerson'
import OrderBlockTwo from './OrderBlockTwo'
import OrderBlockOne from './OrderBlockOne'

function CompanyInfoForm() {
  return (
    <Row gutter={20}>
      <Col span={8}>
        <OrderBlockOne />
      </Col>
      <Col span={8}>
        <OrderBlockTwo />
      </Col>
      <Col span={8}>
        <TrustedPersonForm />
      </Col>
    </Row>
  )
}

export default CompanyInfoForm
